import React, { Component } from 'react'

import { Box } from '@mui/material'
import Dropzone from 'react-dropzone'

import { input } from '@albacross/frontend-utils'

type FileDropzoneProps = {
  onChange: (...args: any[]) => any
  errorId?: string | boolean
  value?: any
  multiple?: boolean
  onFocus?: (...args: any[]) => any
  onBlur?: (...args: any[]) => any
}

class FileDropzone extends Component<FileDropzoneProps> {
  handleChange =
    (p = this.props) =>
    (payload: any, _e: any) =>
      p.multiple ? p.onChange(payload) : p.onChange(payload[0])

  renderValue = (p = this.props) =>
    p.multiple ? p.value.map((file: any, index: number) => <p key={index}>{file.name}</p>) : p.value.name

  renderContent = (p = this.props) => (p.errorId ? p.errorId : p.value ? this.renderValue() : 'Choose or drop file...')

  render() {
    const { errorId, multiple, onFocus, onBlur } = this.props

    return (
      <div>
        <Dropzone multiple={multiple} onDrop={this.handleChange()}>
          {({ getRootProps, getInputProps }) => (
            // onFocus/onBlur keep field focus/blur wired (v7 spread them onto the root); onDragEnter/Leave preserve the drag variant.
            <Box
              {...getRootProps({ onFocus, onBlur, onDragEnter: onFocus, onDragLeave: onBlur })}
              sx={{
                padding: '2rem',
                border: '1px dashed',
                textAlign: 'center',
                cursor: 'pointer',
                ...(errorId ? { borderColor: '#ff5a50', color: '#ff5a50' } : {}),
              }}>
              <input {...getInputProps()} />
              {this.renderContent()}
            </Box>
          )}
        </Dropzone>
      </div>
    )
  }
}

export default input()(FileDropzone)
